import { queryOptions, useQuery, type UseQueryResult } from "@tanstack/react-query";
import { requestKeys } from "@/domains/requests/api/keys";
import type { CameraRequest } from "@/domains/requests/api/types";
import {
  fetchRequestById,
  fetchRequests,
  fetchRequestsByRequester,
} from "@/domains/requests/mocks/requestsService";

export const requestsListOptions = queryOptions({
  queryKey: requestKeys.lists(),
  queryFn: fetchRequests,
});

export const requestsByRequesterOptions = (requesterId: string) =>
  queryOptions({
    queryKey: requestKeys.byRequester(requesterId),
    queryFn: () => fetchRequestsByRequester(requesterId),
  });

export const requestDetailOptions = (id: string) =>
  queryOptions({
    queryKey: requestKeys.detail(id),
    queryFn: () => fetchRequestById(id),
  });

export function useRequests(): UseQueryResult<ReadonlyArray<CameraRequest>> {
  return useQuery(requestsListOptions);
}

export function useRequestsByRequester(
  requesterId: string,
): UseQueryResult<ReadonlyArray<CameraRequest>> {
  return useQuery(requestsByRequesterOptions(requesterId));
}

export function useRequest(id: string): UseQueryResult<CameraRequest | undefined> {
  return useQuery(requestDetailOptions(id));
}
